export default {
    totalItems: state => state.totalItems,
    forms: state => state.forms,
    rowsPerPage: state => state.pagination.rowsPerPage,
    pagination: state => state.pagination
}
